import React from "react";

const Checkbox = ({ id, type, name, handleClicks, isChecked, disableValue, classes }) => {
  return (
    <input
      className={classes}
      id={id}
      name={name}
      type={type}
      disabled={disableValue}
      onChange={handleClicks}
      checked={isChecked}
      style={{marginLeft:'40px'}}
    //   value={payment}
    />
  );
};

export default Checkbox;
